export default __webpack_public_path__ + "static/timberline-education-large-68e9d37c39e3663d27b4a50606f8b764.jpg";